import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/select-menu-arrow.svg'
import _imports_1 from '@/assets/warning-red.svg'


const _hoisted_1 = { class: "text-base leading-[26px] tracking-[0.01rem] font-medium text-[#898790]" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "flex gap-1 items-center mt-1"
}
const _hoisted_5 = { class: "text-[#ed857f] text-sm" }

import { ref } from "vue";
type Props = {
  title: string;
  options?: any;
  isError?: boolean;
  errorMessage?: string;
  modelValue: string;
};

type Emits = {
  (event: "update:modelValue", option: string): void;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'QuestionnaireSelectMenu',
  props: {
    title: {},
    options: {},
    isError: { type: Boolean },
    errorMessage: {},
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const selectModel = ref(props.modelValue ? props.modelValue : "");

const optionsVisible = ref(false);

const toggleOptionsHandler = () => {
  optionsVisible.value = !optionsVisible.value;
};

const selectedOptionHandler = (option: string) => {
  selectModel.value = option;
  optionsVisible.value = false;
  emits("update:modelValue", option);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h4", _hoisted_1, _toDisplayString(__props.title), 1),
    _createElementVNode("div", {
      class: _normalizeClass(["w-full bg-[#F9F8F6] border rounded-primary-radius mt-1", ` ${__props.isError ? 'border-[#ED857F]' : ''} 
          ${!__props.isError && !selectModel.value ? 'border-[#E3E1EA]' : ''} 
          ${selectModel.value && selectModel.value.length > 0 ? 'border-[#393840]' : ''} `])
    }, [
      _createElementVNode("div", {
        onClick: toggleOptionsHandler,
        class: "w-full flex items-center justify-between p-3 h-[50px] cursor-pointer"
      }, [
        _withDirectives(_createElementVNode("input", {
          class: "w-full outline-none bg-transparent text-black placeholder:text-[#898790] cursor-pointer",
          type: "text",
          readonly: "",
          placeholder: "Select",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectModel).value = $event))
        }, null, 512), [
          [_vModelText, selectModel.value]
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("img", {
          src: _imports_0,
          alt: "Arrow down"
        }, null, -1))
      ]),
      (optionsVisible.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("ul", {
              class: _normalizeClass(["options list-none flex flex-col items-start p-3", __props.options && __props.options.length !== 0 ? 'p-3 pt-0' : 'p-0'])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
                return (_openBlock(), _createElementBlock("li", {
                  onClick: ($event: any) => (selectedOptionHandler(option.name)),
                  key: option.id,
                  class: _normalizeClass(["w-full text-base leading-[26px] tracking-[0.01rem] font-medium text-[#898790] hover:bg-[#e5e4e2] cursor-pointer hover:pl-[8px] rounded-lg duration-200", option ? 'pl-0 pr-[5px] py-[10px]' : 'p-0'])
                }, _toDisplayString(option.name), 11, _hoisted_3))
              }), 128))
            ], 2)
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (__props.isError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("img", {
            src: _imports_1,
            alt: "Warning"
          }, null, -1)),
          _createElementVNode("span", _hoisted_5, _toDisplayString(__props.errorMessage), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})